import {MeterIcon, SkipIcon, PlayIcon, NoEntryIcon} from '@primer/octicons-react'
import {RulesetEnforcement} from '@github-ui/repos-rules-types/rules-types'
import {enforcementLabelText} from '../helpers/enforcement-label'
import styles from './EnforcementIcon.module.css'
import {useUpsellInfoContext} from '../contexts/UpsellInfoContext'

export function EnforcementIcon({hideText, enforcement}: {hideText?: boolean; enforcement: RulesetEnforcement}) {
  let text = ''
  let icon: React.ReactElement | null = null
  const upsellInfo = useUpsellInfoContext()

  if (
    upsellInfo &&
    ((!upsellInfo.rulesets.featureEnabled && enforcement !== RulesetEnforcement.Disabled) ||
      (!upsellInfo.enterpriseRulesets.featureEnabled && enforcement === RulesetEnforcement.Evaluate))
  ) {
    text = 'Not enforced'
    icon = <NoEntryIcon className={styles.EnforcementIconOcticonAttention} aria-label="Not enforced" />
  } else {
    text = enforcementLabelText(enforcement)
    switch (enforcement) {
      case RulesetEnforcement.Enabled:
        icon = <PlayIcon className={styles.EnforcementIconOcticonSuccess} aria-label={text} />
        break
      case RulesetEnforcement.Evaluate:
        icon = <MeterIcon className={styles.EnforcementIconOcticonSevere} aria-label={text} />
        break
      default:
        icon = <SkipIcon className={styles.EnforcementIconOcticonMuted} aria-label={text} />
        break
    }
  }

  return hideText ? (
    icon
  ) : (
    <div className={styles.EnforcementIconContainer}>
      {icon}
      <span className={styles.EnforcementIconText}>{text}</span>
    </div>
  )
}
